import { render, staticRenderFns } from "./mandate_data.vue?vue&type=template&id=51880b34&"
import script from "./mandate_data.vue?vue&type=script&lang=js&"
export * from "./mandate_data.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports